import {createSlice} from "@reduxjs/toolkit";
import {getCurrentUserId} from "../../utils/authUtils";

const initialState = {
  currentUserId: getCurrentUserId(),
  users: [],
  usersSearching: [],
  loading: false,
  hasSearched: false
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    fetchAllUsers: (state) => {
      // state.usersSearching = state.usersSearching;
      state.error = false;
      state.loading = true;
    },
    fetchAllUsersSuccess: (state, action) => {
      state.currentUserId = getCurrentUserId();
      state.users = action.payload;
      state.error = false;
      state.loading = false;
    },
    fetchAllUsersFailure: (state) => {
      state.users = [];
      state.error = true;
      state.loading = false;
    }
  }
});

export const {fetchAllUsers, fetchAllUsersSuccess, fetchAllUsersFailure} =
  usersSlice.actions;

export default usersSlice.reducer;
